import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1a9c68f8")

_pushScopeId("data-v-1a9c68f8")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("同意事項")
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "dialog-footer" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_link = _resolveComponent("el-link")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_el_link, {
      icon: "el-icon-document",
      type: "primary",
      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.isDoiJikoDialogVisible = true), ["prevent"]))
    }, {
      default: _withId(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    (_ctx.isDoiJikoDialogVisible)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 0,
          modelValue: _ctx.isDoiJikoDialogVisible,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.isDoiJikoDialogVisible = $event)),
          title: "同意事項",
          width: "50%",
          center: ""
        }, {
          footer: _withId(() => [
            _hoisted_2
          ]),
          default: _withId(() => [
            _createVNode("div", {
              innerHTML: _ctx.doiJikoContent.replaceAll('\n', '<br />'),
              class: "doiJiko"
            }, null, 8, ["innerHTML"])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ], 64))
})